/* unplugin-vue-components disabled */import { render } from "./RoleListView.vue?vue&type=template&id=180d79da&scoped=true"
import script from "./RoleListView.vue?vue&type=script&lang=js"
export * from "./RoleListView.vue?vue&type=script&lang=js"

import "./RoleListView.vue?vue&type=style&index=0&id=180d79da&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180d79da"]])

export default __exports__